import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'login',
    component: () => import(/* webpackChunkName: "about" */ '../views/login/loginPage.vue')
  },
  {
    path: '/cageinfo',
    name: 'cageinfo',
    component: () => import(/* webpackChunkName: "about" */ '../views/cageInfos/cageInfo.vue'),
  },
  {
    path: '/homepage',
    name: 'homepage',
    component: () => import(/* webpackChunkName: "about" */ '../views/home/homepage.vue')
  },
  {
    path: '/cageinfo/drugtestdetail',
    name: 'drugtestdetail',
    component: () => import(/* webpackChunkName: "about" */ '../components/CageDetails/DrugtestDetail.vue'),
  },
  {
    path: '/cageinfo/coitusdetail',
    name: 'coitusdetail',
    component: () => import(/* webpackChunkName: "about" */ '../components/CageDetails/CoitusDetail.vue'),
  },
  {
    path: '/cageinfo/feedingdetail',
    name: 'feedingdetail',
    component: () => import(/* webpackChunkName: "about" */ '../components/CageDetails/FeedingDetail.vue'),
  },
  {
    path: '/taskmanage-tracesource',
    name: 'taskmanage-tracesource',
    component: () => import(/* webpackChunkName: "about" */ '../views/suyuan/suyuanPage.vue')
  },
  {
    path: '/taskmanage-tracesource/findup',
    name: 'upfind',
    component: () => import(/* webpackChunkName: "about" */ '../views/suyuan/suyuan/SuYuan.vue')
  },
  {
    path: '/taskmanage-matingtask',
    name: 'taskmanage-matingtask',
    component: () => import(/* webpackChunkName: "about" */ '../views/matingtask/matingTask.vue')
  },
  {
    path: '/taskmanage-dividecagetask',
    name: 'taskmanage-dividecagetask',
    component: () => import(/* webpackChunkName: "about" */ '../views/dividecagetask/dividecageTask.vue')
  },
  {
    path: '/taskmanage-transfertask',
    name: 'taskmanage-transfertask',
    component: () => import(/* webpackChunkName: "about" */ '../views/transfertask/transferTask.vue')
  },
  {
    path: '/cageentry',
    name: 'cageentry',
    component: () => import(/* webpackChunkName: "about" */ '../views/cageInfos/cageentry/cageEntry.vue')
  },
  {
    path: '/taskmanage-expmouse',
    name: 'taskmanage-expmouse',
    component: () => import(/* webpackChunkName: "about" */ '../views/expmouse/expMouse.vue')
  },
  {
    path: '/taskmanage-expmouse/publishtask',
    name: 'publishtask',
    component: () => import(/* webpackChunkName: "about" */ '../views/expmouse/publishtask/publishTask.vue')
  },
  {
    path: '/taskmanage-expmouse/drugtestdetail',
    name: 'expdrugtestdetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/expmouse/alldetail/drugtestDetail.vue'),
  },
  {
    path: '/taskmanage-matingtask/matingdetail',
    name: 'matingdetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/matingtask/alldetail/matingDetail.vue'),
  },
  {
    path: '/taskmanage-matingtask/matingcagedetail',
    name: 'matingcagedetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/matingtask/alldetail/matingCageDetail.vue'),
  },
  {
    path: '/taskmanage-expmouse/expmousedetail',
    name: 'expmousedetail',
    component: () => import(/* webpackChunkName: "about" */ '../views/expmouse/alldetail/expmouseDetail.vue'),
  },
  {
    path: '/taskmanage-matingtask/checkmice',
    name: 'checkmice',
    component: () => import(/* webpackChunkName: "about" */ '../views/matingtask/alldetail/reportMice.vue'),
  },
  {
    path: '/taskmanage-newmice',
    name: 'taskmanage-newmice',
    component: () => import(/* webpackChunkName: "about" */ '../views/newmice/newmiceEntry.vue'),
  },
  {
    path: '/taskmanage-geneidentify',
    name: 'taskmanage-geneidentify',
    component: () => import(/* webpackChunkName: "about" */ '../views/geneidentify/geneIdentify.vue'),
  },
  {
    path: '/taskmanage-geneentry',
    name: 'taskmanage-geneentry',
    component: () => import(/* webpackChunkName: "about" */ '../views/geneentry/geneEntry.vue'),
  },
  {
    path: '/taskmanage-agendaboard',
    name: 'taskmanage-agendaboard',
    component: () => import(/* webpackChunkName: "about" */ '../views/agendaboard/agendAboard.vue'),
  },
  {
    path: '/taskmanage-inforeporting',
    name: 'taskmanage-inforeporting',
    component: () => import(/* webpackChunkName: "about" */ '../views/inforeporting/infoReporting.vue'),
  },
  {
    path: '/taskmanage-config',
    name: 'taskmanage-config',
    component: () => import(/* webpackChunkName: "about" */ '../views/configmanage/configPage.vue')
  },
  {
    path: '/usermanage',
    name: 'usermanage',
    component: () => import(/* webpackChunkName: "about" */ '../views/usermanage/userManage.vue')
  },
  {
    path: '/usermanage-infostatistics',
    name: 'usermanage-infostatistics',
    component: () => import(/* webpackChunkName: "about" */ '../views/infoStatistics/infoStatistics.vue')
  },
  {
    path: '/usermanage-authority',
    name: 'usermanage-authority',
    component: () => import(/* webpackChunkName: "about" */ '../views/authoritymanage/authorityManage.vue')
  },
  {
    path: '/usermanage-proxy',
    name: 'usermanage-proxy',
    component: () => import(/* webpackChunkName: "about" */ '../views/proxymanage/proxyManage.vue')
  },
  {
    path: '/usermanage-micemanage',
    name: 'usermanage-micemanage',
    component: () => import(/* webpackChunkName: "about" */ '../views/micemanage/miceManage.vue')
  },
  {
   path: '/usercenter',
   name: 'usercenter',
   component: () => import(/* webpackChunkName: "about" */ '../views/userinfo/usercenter.vue')
 },
  {
    path: '/usermanage-region',
    name: 'usermanage-region',
    component: () => import(/* webpackChunkName: "about" */ '../views/userinfo/regionManage.vue')
  },
 {
    path: '/messagebox',
    name: 'messagebox',
    component: () => import(/* webpackChunkName: "about" */ '../views/messagebox/messageBox.vue')
  },
  {
    path: '/taskmanage-eliminate',
    name: 'taskmanage-eliminate',
    component: () => import(/* webpackChunkName: "about" */ '../views/eliminatetask/eliminateTask.vue')
  },

  {
    path: '/usermanage-log',
    name: 'usermanage-log',
    component: () => import(/* webpackChunkName: "about" */ '../views/userinfo/logManage.vue')
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
